import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const ChevronUp: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M18 15L12 9L6 15"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
